'use client'

import { AppLayout } from '../../components/AppLayout'
import { withEnvs } from './withEnvs'

export const AppLayoutWithEnvs = withEnvs(AppLayout)
